import styled from "@emotion/styled";

// Dashboard container
export const DashboardContainer = styled.div`
  display: grid;
  grid-template-rows: 63.8% 36.2%;
  height: 100%;
`;

export const ClientsContainer = styled.div`
  display: grid;
  padding: 3rem;
`;
export const AdminsContainer = styled.div`
  display: grid;
  border-top: 1px solid #e4e4e4;
  padding: 3rem;
`;
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
